import { faBan } from "@fortawesome/pro-regular-svg-icons/faBan";
import { Typography } from "@mui/material";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import UserProfileLink from "components/UserProfileLink";
import { FeedItemPublicationDto } from "models/ApiModels";
import * as React from "react";
import { Trans } from "react-i18next";

interface IProps {
    publication: FeedItemPublicationDto;
}

export const PublicationUserBlockedInfo: React.FC<IProps> = (props) => {
    return props.publication.bannedByAuthor
            ? (
                <MuiMessageBox
                    icon={faBan}
                    variant={"error"}
                    message={
                        <div>
                            <MuiContainer>
                                <Typography variant="h5">
                                    {props.publication.title}
                                </Typography>
                            </MuiContainer>

                            <Typography variant="body2" color="inherit">
                                <Trans
                                    i18nKey="Views.Publication.Components.PublicationUserBlockedInfo.BlockedByAuthorMessage"
                                    components={
                                        [
                                            <UserProfileLink user={props.publication.publisher} inheritColor />
                                        ]
                                    }
                                />
                            </Typography>
                        </div>
                    }
                />
            )
            : null;
};